export default "__VITE_ASSET__CeKs1wyL__"